"use client"

import { useState } from "react"
import { useNavigate } from "react-router"
import { Bell } from "lucide-react"
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar"
import { NotificationsModal } from "@/components/ui/notifications/notifications-modal"

export function SettingsTitle() {
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false)
  const navigate = useNavigate()

  // Mock function to handle marking notifications as read
  const handleMarkAsRead = (notificationId: string) => {
    console.log("Marking notification as read:", notificationId)
    // Implement your logic to mark notification as read
  }

  const handleMarkAllAsRead = () => {
    console.log("Marking all notifications as read")
    // Implement your logic to mark all notifications as read
  }

  const handleAvatarClick = () => {
    navigate("/profile")
  }

  return (
    <>
      <div className="mb-8 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h2 className="text-4xl font-bold text-slate-900 mb-2">Settings</h2>
          <p className="text-base font-normal text-slate-600">Manage your account and app preferences.</p>
        </div>

        <div className="flex items-center gap-4">
          {/* Notifications Bell Button */}
          <button
            onClick={() => setIsNotificationsOpen(true)}
            className="relative p-2 rounded-full hover:bg-slate-100 text-slate-600 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            aria-label="View notifications"
          >
            <Bell className="w-6 h-6 hover:text-blue-600 transition-colors" />
            <span className="absolute top-1 right-1 block h-2.5 w-2.5 rounded-full bg-red-500 border-2 border-white animate-pulse"></span>
          </button>

          {/* Avatar with Profile Routing */}
          <button
            onClick={handleAvatarClick}
            className="transition-transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-full"
            aria-label="Go to profile"
          >
            <Avatar className="w-10 h-10 border-2 border-blue-600 cursor-pointer">
              <AvatarImage
                src="https://lh3.googleusercontent.com/a/AGNmyxb00bCTDmJ85V-aOqz-8K-PtJ0WyxPNQpP6kO0G=s96-c"
                alt="User Avatar"
              />
              {/* <AvatarFallback className="bg-blue-100 text-blue-700 font-semibold">
               
              </AvatarFallback> */}
            </Avatar>
          </button>
        </div>
      </div>

      {/* Notifications Modal */}
      <NotificationsModal
        isOpen={isNotificationsOpen}
        onClose={() => setIsNotificationsOpen(false)}
        onMarkAsRead={handleMarkAsRead}
        onMarkAllAsRead={handleMarkAllAsRead}
        position="top-right"
      />
    </>
  )
}